export default __webpack_public_path__ + "static/media/MCSW-team.022103b0.png";